import React, { useState, useEffect } from "react";
import { Container, Flag, Arrow } from "./LanguageSelect.styles";
import LanguageModal from "./LanguageModal/LanguageModal";
import flagUK from "../../assets/images/flags/flagUK.svg";
import flagUS from "../../assets/images/flags/flagUS.svg";
import flagRU from "../../assets/images/flags/flagRU.svg";
import arrow from "../../assets/images/arrow.svg";
import arrowUp from "../../assets/images/arrowUp.svg";
import i18n from "../../i18n";

const LanguageSelect = () => {
  const [showLanguageModal, setShowLanguageModal] = useState(false);
  const [lang, setLang] = useState(flagUK);

  const selectLanguage = () => {
    setShowLanguageModal(!showLanguageModal);
  };

  const { language } = i18n;

  useEffect(() => {
    const flag = () => {
      if (language.substring(0, 2) === "uk") {
        setLang(flagUK);
      } else if (language.substring(0, 2) === "ru") {
        setLang(flagRU);
      } else {
        setLang(flagUS);
      }
    };
    
    flag();
  }, [language]);

  return (
    <Container onClick={selectLanguage}>
      <div>
        <Flag src={lang} />
        <Arrow
          src={showLanguageModal ? arrowUp : arrow}
          alt="arrow"
          role="presentation"
        />
      </div>
      {showLanguageModal && (
        <LanguageModal
          closeModal={() => setShowLanguageModal(!showLanguageModal)}
        />
      )}
    </Container>
  );
};

export default LanguageSelect;
